import { clampPct } from '../tag-color-utils'

interface Props {
  hue: number
  s: number
  v: number
  onChange(s: number, v: number): void
}

/**
 * 2D pad for picking saturation (x axis) and value (y axis) of an HSV color.
 *
 * Pointer capture lets users drag the selector outside the pad bounds; we clamp
 * the resulting values to [0, 100] so the handle never escapes the gradient.
 */
export const SaturationValuePad: React.FC<Props> = ({
  hue,
  s,
  v,
  onChange,
}) => {
  function handlePointer(evt: React.PointerEvent<HTMLDivElement>) {
    if (evt.buttons !== 1 && evt.type !== 'pointerdown') return
    const rect = evt.currentTarget.getBoundingClientRect()
    const nx = clampPct(((evt.clientX - rect.left) / rect.width) * 100)
    const ny = clampPct(100 - ((evt.clientY - rect.top) / rect.height) * 100)
    onChange(nx, ny)
  }

  return (
    <div
      className="relative h-32 w-full rounded-md cursor-crosshair touch-none"
      style={{
        background: `linear-gradient(to top, #000, transparent), linear-gradient(to right, #fff, hsl(${hue}, 100%, 50%))`,
      }}
      onPointerDown={evt => {
        evt.currentTarget.setPointerCapture(evt.pointerId)
        handlePointer(evt)
      }}
      onPointerMove={handlePointer}
    >
      <div
        className="absolute size-3 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow"
        style={{ left: `${s}%`, top: `${100 - v}%` }}
      />
    </div>
  )
}
